<ion-checkbox [class.rounded]="roundBorder" [formControl]="innerControl" click-stop-propagation></ion-checkbox>
